import { PublishingRuleCreateSchema } from "../../types";

export interface ValidationErrors {
  from_date?: string;
  to_date?: string;
  publications?: string;
  publicationDays?: string;
}

export const validateSchedule = (
  schedule: PublishingRuleCreateSchema,
): ValidationErrors => {
  const errors: ValidationErrors = {};

  if (!schedule.from_date) {
    errors.from_date = "Startdatum krävs";
  }

  if (!schedule.to_date) {
    errors.to_date = "Slutdatum krävs";
  }

  if (
    schedule.from_date &&
    schedule.to_date &&
    schedule.from_date > schedule.to_date
  ) {
    errors.to_date = "Slutdatum måste vara efter startdatum";
  }

  if (!schedule.publications.length) {
    errors.publications = "Minst en tidning måste väljas";
  }

  return errors;
};
